// extracted by mini-css-extract-plugin
module.exports = {"list":"style__list___sXSVw","item":"style__item___3Ltyn"};